import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@/components/ui/button";
import { Clock, LogOut } from "lucide-react";

export default function AwaitingAccess() {
  const { logout, user } = useAuth0();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center space-y-6">
        <div className="mx-auto w-16 h-16 rounded-full bg-warning/10 flex items-center justify-center">
          <Clock className="h-8 w-8 text-warning" />
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">Aguardando acesso</h1>
          <p className="text-muted-foreground">
            Sua conta <span className="font-medium text-foreground">{user?.email}</span> foi criada,
            mas você ainda não foi convidado para nenhuma empresa.
          </p>
          <p className="text-muted-foreground text-sm">
            Peça a um administrador para enviar um convite ao seu email.
          </p>
        </div>
        <Button
          variant="outline"
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          className="gap-2"
        >
          <LogOut className="h-4 w-4" />
          Sair
        </Button>
      </div>
    </div>
  );
}
